import React from 'react';
import { Flex, Heading, Text } from '@applyboard/crystal-ui';

import { useAppProcessing } from '~/pages/ApplicationDetails/context';
import { AttachedDocuments } from '../Cards/shared/AttachedDocuments';
import { EducationHistory } from '~/data/useApplication';

type SupportingDocumentsSectionProps = {
  educationHistoryItem?: EducationHistory;
};

export function SupportingDocumentsSection(props?: SupportingDocumentsSectionProps) {
  const {
    application: { educationHistories },
  } = useAppProcessing();

  const primaryEducationHistoryItem = props?.educationHistoryItem ?? educationHistories.educationHistoryItems[0];

  if (!primaryEducationHistoryItem) return null;

  const documents = primaryEducationHistoryItem.documents;
  const hasTranscriptDocuments = documents.some((doc) => doc.type.code === 'TRANSCRIPTS');
  const hasCertificateDocuments = documents.some((doc) => doc.type.code === 'CERTIFICATE');
  const hasDocuments = hasTranscriptDocuments || hasCertificateDocuments;

  return (
    <Flex direction="column" gap={4}>
      <Heading level={3}>Supporting documents</Heading>
      {hasDocuments ? (
        <>
          {hasTranscriptDocuments && (
            <>
              <Text variant="bodyM" intent="secondary">
                Transcript
              </Text>
              <AttachedDocuments
                showTitle={false}
                attachmentDocuments={documents}
                section="educationHistory"
                sectionReference={primaryEducationHistoryItem.key}
                types={['TRANSCRIPTS']}
              />
            </>
          )}

          {hasCertificateDocuments && (
            <>
              <Text variant="bodyM" intent="secondary">
                Certificate
              </Text>
              <AttachedDocuments
                showTitle={false}
                attachmentDocuments={documents}
                section="educationHistory"
                sectionReference={primaryEducationHistoryItem.key}
                types={['CERTIFICATE']}
              />
            </>
          )}
        </>
      ) : (
        <Text variant="bodyM" intent="secondary">
          No supporting documents have been uploaded for this education history.
        </Text>
      )}
    </Flex>
  );
}
